import { render, staticRenderFns } from "./PathEditor.vue?vue&type=template&id=0576a7cf&scoped=true&"
import script from "./PathEditor.vue?vue&type=script&lang=js&"
export * from "./PathEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0576a7cf",
  null
  
)

export default component.exports